/**
 * @description Subjects used in email templates for teacher-only users
 */
export enum EMAIL_SUBJECT {
  Welcome_Email = 'Welcome to Respond EDU – Your Quick Start Guide!',
  First_Classroom_Setup_Mail = 'Congratulations on Your First Classroom and Pacing Plan! 🎉',
}

/**
 * @description Common CSS styles applied to email templates sent to teacher-only users
 */
export const EMAIL_CSS = `
  .info-text {
    font-family: Quicksand;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    color: #000;
  }
  .logo-img {
    width: 182px;
  }
`;

/**
 * @description Identifiers for the type of email template to be used for teacher-only users
 */
export enum EMAIL_TEMPLATE_TYPE {
  WELCOME = 'welcome',
  FIRST_CLASSROOM_SETUP_MAIL = 'first_classroom_setup_mail',
}
